interface StatusStatsProps {
  readonly statusCounts: Record<string, number>;
  readonly maxStatusCount: number;
}

export function StatusStats({
  statusCounts,
  maxStatusCount,
}: StatusStatsProps) {
  return (
    <div className="p-5 bg-surface border border-border rounded-xl">
      <div className="text-sm font-semibold text-ink mb-4">
        Tâches par statut
      </div>
      <div className="space-y-3">
        <StatusBar
          label="À faire"
          count={statusCounts.todo}
          maxCount={maxStatusCount}
          barColor="bg-accent"
        />
        <StatusBar
          label="En cours"
          count={statusCounts.doing}
          maxCount={maxStatusCount}
          barColor="bg-amber-400"
        />
        <StatusBar
          label="Fait"
          count={statusCounts.done}
          maxCount={maxStatusCount}
          barColor="bg-success"
        />
      </div>
    </div>
  );
}

interface StatusBarProps {
  readonly label: string;
  readonly count: number;
  readonly maxCount: number;
  readonly barColor: string;
}

function StatusBar({ label, count, maxCount, barColor }: StatusBarProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center justify-between text-sm">
        <span className="text-ink-muted">{label}</span>
        <span className="font-medium text-ink">{count}</span>
      </div>
      <div className="w-full h-2 bg-surface-alt rounded-full overflow-hidden">
        <div
          className={`h-full ${barColor} rounded-full`}
          style={{
            width: `${maxCount > 0 ? (count / maxCount) * 100 : 0}%`,
          }}
        />
      </div>
    </div>
  );
}
